import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store/store'
import './i18n/i18n'
import App from './App.tsx'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Impressum from './pages/Impressum'
import Datenschutz from './pages/Datenschutz'
import Kontakt from './pages/Kontakt'
import NotFound from './pages/NotFound'
import './index.css'
import Leistungen from './pages/Leistungen'
import Referenzen from './pages/Referenzen'
import ReferenzDetail from './pages/ReferenzDetail'
import { AppThemeProvider } from './theme'
import { AuthProvider } from './context/AuthContext'
import Login from './pages/Login'
import OAuthCallback from './pages/OAuthCallback'

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/login', element: <Login /> },
  { path: '/oauth2/callback', element: <OAuthCallback /> },
  { path: '/leistungen', element: <Leistungen /> },
  { path: '/referenzen', element: <Referenzen /> },
  { path: '/referenzen/:slug', element: <ReferenzDetail /> },
  { path: '/kontakt', element: <Kontakt /> },
  { path: '/impressum', element: <Impressum /> },
  { path: '/datenschutz', element: <Datenschutz /> },
  { path: '/404', element: <NotFound /> },
  { path: '*', element: <NotFound /> }
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <AppThemeProvider>
          <RouterProvider router={router} />
        </AppThemeProvider>
      </AuthProvider>
    </Provider>
  </React.StrictMode>,
)
